// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"a09e0030","787":"e03a934c"}[chunkId] + ".chunk.js";
};